import { SelfServiceAPI } from 'types';
import getFormattedCheckInDateTime from '../getFormattedCheckInDateTime';
import getFormattedCheckOutDateTime from '../getFormattedCheckOutDateTime';
import getGuestSummary from '../getGuestSummary';

const getDescription = (booking: SelfServiceAPI.Booking) =>
  `You're staying ${booking.summaryText}. Enjoy your trip.


Booking details

Check-in date: ${getFormattedCheckInDateTime(booking)}
Check-out date: ${getFormattedCheckOutDateTime(booking)}
Guests: ${getGuestSummary(booking)}
View your booking online:
${booking.links.manage}


Hotel details

Room: ${booking.reservation.roomType.name}
Address: ${booking.reservation.property.formattedAddressFull}
`;

export default getDescription;
